import { getLocale } from "../runtime";

const sv_nocountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Norge`
};

const nocountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_nocountry(inputs)
	return "noCountry";
};

export { nocountry as "noCountry" };